import { InjectionToken, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { buildPathWithMap, RouteSubModule } from 'authorization';
import { AppRoute } from './app.route';
import { PageNotFoundComponent } from 'src/domains/share/app/component/page-notFoud/page-notFound.component';
import { MainPageLayoutComponent } from './component/main-page-layout/main-page-layout.component';
import { SiteManagmentRouting } from 'src/domains/site-managment/site-managment.routing';
import { AuthenticationRouting } from 'src/domains/authentication/authentication.routing';
import { themeRouting } from 'src/domains/theme/theme.routing';
import { MaintenanceGuard } from 'catch-error';
import { schematicsGuiRouting } from 'schematics-gui';
import { AppRouteStrategyGuard } from 'src/domains/authentication/app/service/app-authorization-guard';
import { DependentApiUpdate } from './util/service/dependent-api-update.service';

export const DEPENDENT_API_UPDATE = new InjectionToken<DependentApiUpdate>(
  'DEPENDENT_API_UPDATE',
);
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'site_managment',
  },
  {
    path: '',
    children: [
      {
        path: 'site_managment',
        children: [...SiteManagmentRouting],
      } as RouteSubModule<typeof AppRoute.map, 'site_managment'>,

      {
        path: 'auth',
        children: [...AuthenticationRouting],
      } as RouteSubModule<typeof AppRoute.map, 'auth'>,

      {
        path: 'theme',
        children: [...themeRouting],
      } as RouteSubModule<typeof AppRoute.map, 'theme'>,
      {
        path: 'schematics',
        children: [...schematicsGuiRouting],
      } as RouteSubModule<typeof AppRoute.map, 'schematics'>,
      {
        path: '**',
        pathMatch: 'full',
        component: MainPageLayoutComponent,
        children: [
          { path: '', pathMatch: 'full', component: PageNotFoundComponent },
        ],
      },
    ],

    canActivate: [AppRouteStrategyGuard, MaintenanceGuard],
    canActivateChild: [AppRouteStrategyGuard, MaintenanceGuard],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const appRouteIndex = buildPathWithMap(AppRoute.map, '');
